import { render, staticRenderFns } from "./UIGameHeaderDetail.vue?vue&type=template&id=e81b395e&scoped=true&"
import script from "./UIGameHeaderDetail.vue?vue&type=script&lang=js&"
export * from "./UIGameHeaderDetail.vue?vue&type=script&lang=js&"
import style0 from "./UIGameHeaderDetail.vue?vue&type=style&index=0&id=e81b395e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81b395e",
  null
  
)

export default component.exports